import {
  AccountClusterCount,
  BodyHashClusterItem,
  DecisionBody,
  DecisionRecord,
  ErrorEntry,
  EventDetailResponse,
  FanOutResult,
  LockHolder,
  QueueFilters,
  QueueListItem,
} from '../models';
import {
  Action,
  CM_BODYHASH_FETCH_FAILURE,
  CM_BODYHASH_FETCH_REQUESTED,
  CM_BODYHASH_FETCH_SUCCESS,
  CM_CLUSTER_FETCH_FAILURE,
  CM_CLUSTER_FETCH_REQUESTED,
  CM_CLUSTER_FETCH_SUCCESS,
  CM_DECISION_RESET_FAILURE,
  CM_DECISION_RESET_REQUESTED,
  CM_DECISION_RESET_SUCCESS,
  CM_DECISION_SUBMIT_FAILURE,
  CM_DECISION_SUBMIT_REQUESTED,
  CM_DECISION_SUBMIT_SUCCESS,
  CM_DETAIL_CLEAR,
  CM_DETAIL_FETCH_FAILURE,
  CM_DETAIL_FETCH_REQUESTED,
  CM_DETAIL_FETCH_SUCCESS,
  CM_FANOUT_EVENT_RESULT,
  CM_FANOUT_FINISH,
  CM_FANOUT_RESET,
  CM_FANOUT_SELECT_SET,
  CM_FANOUT_SELECT_TOGGLE,
  CM_FANOUT_START,
  CM_KEYBOARD_SET,
  CM_LOCK_ACQUIRE_FAILURE,
  CM_LOCK_ACQUIRE_HELD,
  CM_LOCK_ACQUIRE_HELD_BY_OTHER,
  CM_LOCK_ACQUIRE_REQUESTED,
  CM_LOCK_HEARTBEAT_FAILURE,
  CM_LOCK_HEARTBEAT_SUCCESS,
  CM_LOCK_RELEASE,
  CM_MODAL_CLOSE,
  CM_MODAL_OPEN,
  CM_QUEUE_APPEND_FAILURE,
  CM_QUEUE_APPEND_REQUESTED,
  CM_QUEUE_APPEND_SUCCESS,
  CM_QUEUE_FETCH_FAILURE,
  CM_QUEUE_FETCH_REQUESTED,
  CM_QUEUE_FETCH_SUCCESS,
  CM_QUEUE_FILTERS_SET,
  ContentModerationModal,
} from './contentModerationTypes';

export const queueFetchRequested = (isPoll: boolean): Action => ({
  type: CM_QUEUE_FETCH_REQUESTED,
  isPoll,
});
export const queueFetchSuccess = (
  items: QueueListItem[],
  totalCount: number,
  page: number,
  pageSize: number,
  at: number,
): Action => ({
  type: CM_QUEUE_FETCH_SUCCESS,
  items,
  totalCount,
  page,
  pageSize,
  at,
});
export const queueFetchFailure = (error: ErrorEntry): Action => ({
  type: CM_QUEUE_FETCH_FAILURE,
  error,
});
export const queueFiltersSet = (filters: QueueFilters): Action => ({
  type: CM_QUEUE_FILTERS_SET,
  filters,
});

export const queueAppendRequested = (): Action => ({ type: CM_QUEUE_APPEND_REQUESTED });
export const queueAppendSuccess = (
  items: QueueListItem[],
  totalCount: number,
  page: number,
  pageSize: number,
): Action => ({
  type: CM_QUEUE_APPEND_SUCCESS,
  items,
  totalCount,
  page,
  pageSize,
});
export const queueAppendFailure = (error: ErrorEntry): Action => ({
  type: CM_QUEUE_APPEND_FAILURE,
  error,
});

export const detailFetchRequested = (): Action => ({ type: CM_DETAIL_FETCH_REQUESTED });
export const detailFetchSuccess = (detail: EventDetailResponse): Action => ({
  type: CM_DETAIL_FETCH_SUCCESS,
  detail,
});
export const detailFetchFailure = (error: ErrorEntry): Action => ({
  type: CM_DETAIL_FETCH_FAILURE,
  error,
});
export const detailClear = (): Action => ({ type: CM_DETAIL_CLEAR });

export const clusterFetchRequested = (accountId: number): Action => ({
  type: CM_CLUSTER_FETCH_REQUESTED,
  accountId,
});
export const clusterFetchSuccess = (cluster: AccountClusterCount): Action => ({
  type: CM_CLUSTER_FETCH_SUCCESS,
  cluster,
});
export const clusterFetchFailure = (error: ErrorEntry): Action => ({
  type: CM_CLUSTER_FETCH_FAILURE,
  error,
});

export const bodyHashFetchRequested = (eventId: number): Action => ({
  type: CM_BODYHASH_FETCH_REQUESTED,
  eventId,
});
export const bodyHashFetchSuccess = (items: BodyHashClusterItem[]): Action => ({
  type: CM_BODYHASH_FETCH_SUCCESS,
  items,
});
export const bodyHashFetchFailure = (error: ErrorEntry): Action => ({
  type: CM_BODYHASH_FETCH_FAILURE,
  error,
});

export const lockAcquireRequested = (): Action => ({ type: CM_LOCK_ACQUIRE_REQUESTED });
export const lockAcquireHeld = (
  holder: LockHolder | null,
  lastHeartbeatAt: string | null,
): Action => ({ type: CM_LOCK_ACQUIRE_HELD, holder, lastHeartbeatAt });
export const lockAcquireHeldByOther = (
  holder: LockHolder | null,
  lastHeartbeatAt: string | null,
): Action => ({ type: CM_LOCK_ACQUIRE_HELD_BY_OTHER, holder, lastHeartbeatAt });
export const lockAcquireFailure = (error: ErrorEntry): Action => ({
  type: CM_LOCK_ACQUIRE_FAILURE,
  error,
});
export const lockHeartbeatSuccess = (lastHeartbeatAt: string): Action => ({
  type: CM_LOCK_HEARTBEAT_SUCCESS,
  lastHeartbeatAt,
});
export const lockHeartbeatFailure = (error: ErrorEntry): Action => ({
  type: CM_LOCK_HEARTBEAT_FAILURE,
  error,
});
export const lockRelease = (): Action => ({ type: CM_LOCK_RELEASE });

export const decisionSubmitRequested = (body: DecisionBody): Action => ({
  type: CM_DECISION_SUBMIT_REQUESTED,
  body,
});
export const decisionSubmitSuccess = (
  decision: DecisionRecord,
  warnings: ErrorEntry[],
): Action => ({ type: CM_DECISION_SUBMIT_SUCCESS, decision, warnings });
export const decisionSubmitFailure = (error: ErrorEntry): Action => ({
  type: CM_DECISION_SUBMIT_FAILURE,
  error,
});

export const decisionResetRequested = (): Action => ({ type: CM_DECISION_RESET_REQUESTED });
export const decisionResetSuccess = (): Action => ({ type: CM_DECISION_RESET_SUCCESS });
export const decisionResetFailure = (error: ErrorEntry): Action => ({
  type: CM_DECISION_RESET_FAILURE,
  error,
});

export const fanOutSelectSet = (eventIds: number[]): Action => ({
  type: CM_FANOUT_SELECT_SET,
  eventIds,
});
export const fanOutSelectToggle = (eventId: number): Action => ({
  type: CM_FANOUT_SELECT_TOGGLE,
  eventId,
});
export const fanOutStart = (eventIds: number[]): Action => ({
  type: CM_FANOUT_START,
  eventIds,
});
export const fanOutEventResult = (result: FanOutResult): Action => ({
  type: CM_FANOUT_EVENT_RESULT,
  result,
});
export const fanOutFinish = (): Action => ({ type: CM_FANOUT_FINISH });
export const fanOutReset = (): Action => ({ type: CM_FANOUT_RESET });

export const modalOpen = (modal: ContentModerationModal): Action => ({
  type: CM_MODAL_OPEN,
  modal,
});
export const modalClose = (): Action => ({ type: CM_MODAL_CLOSE });
export const keyboardSet = (enabled: boolean): Action => ({
  type: CM_KEYBOARD_SET,
  enabled,
});
